/* eslint-disable @typescript-eslint/no-explicit-any */
import type { FormFields } from './types'

import { COMMUNITY_TYPE } from '../accessAndPrivacy/constants'

export const formFields: FormFields = {
  description: {
    name: 'description',
    value: ''
  },
  name: {
    name: 'name',
    value: ''
  },
  icon: {
    name: 'icon',
    value: ''
  },
  communityType: {
    name: 'communityType',
    value: COMMUNITY_TYPE.OPEN
  },
  idGroup: {
    name: 'idGroup',
    value: undefined
  },
  collaborativeContent: {
    name: 'collaborativeContent',
    value: true
  },
  defaultEnableComments: {
    name: 'defaultEnableComments',
    value: true
  },
  hide: {
    name: 'hide',
    value: false
  },
  moderationCommunity: {
    name: 'moderationCommunity',
    value: false
  }
}

export const formFieldsValidator: Record<
  keyof FormFields,
  Record<'isValid', (value: any) => boolean>
> = {
  description: {
    isValid: (value: string) => value?.trim().length > 0
  },
  icon: {
    isValid: () => true
  },
  name: {
    isValid: (value: string) => value?.trim().length > 0
  },
  communityType: {
    isValid: (value: number) => !isNaN(Number(value))
  },
  idGroup: {
    isValid: (value?: number) => !isNaN(Number(value))
  },
  collaborativeContent: {
    isValid: (value: unknown) => typeof value === 'boolean'
  },
  defaultEnableComments: {
    isValid: (value: unknown) => typeof value === 'boolean'
  },
  hide: {
    isValid: (value: unknown) => typeof value === 'boolean'
  },
  moderationCommunity: {
    isValid: (value: unknown) => typeof value === 'boolean'
  }
}

export const getFieldsConfig = (data: FormFields) => ({
  [formFields.description.name]: {
    maxSize: 200,
    currentSize: data.description.value?.length ?? 0
  },
  [formFields.name.name]: {
    maxSize: 64,
    currentSize: data.name.value?.length ?? 0
  }
})

export const EDIT_COMMUNITY_SUCCESS = 'EDIT_COMMUNITY_SUCCESS'
